import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { PhoneInput } from "../ui/input-phone";
import { Label } from "../ui/label";
type Props = {
  name: string;
  label?: string;

  required?: boolean;
  disabled?: Boolean;
  placeholder?: string;
  defaultvalue?: string;
};
const RhfPhone = ({
  name,
  label,
  required = false,
  disabled = false,
  defaultvalue = "",
  ...props
}: Props) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultvalue}
      disabled={!!disabled}
      render={({ field, fieldState, formState }) => (
        <div className="space-y-2">
          <Label 
          // className={`${fieldState.error?.message ? "text-destructive" : ""}`}  
          htmlFor={name} >{label}{required? "*": ""}</Label>
          <PhoneInput {...field}  />
          {fieldState.error && <p className="text-destructive text-sm">
            {fieldState.error?.message}
          </p> }
        </div>
      )}
    />
  );
};

export default RhfPhone;
